/*>
* @license
* Copyright (c) 2014-2022 ABILITY Network, Inc., an INOVALON, Inc. company. All Rights Reserved.
* 
* This computer program is CONFIDENTIAL and a TRADE SECRET of ABILITY Network, Inc.
* The receipt or possession of this program does not convey any rights to use,
* reproduce or disclose its contents in whole or in part, without the specific
* written consent of ABILITY Network, Inc. Any use, reproduction or disclosure of
* this program without the express written consent of ABILITY Network, Inc. is a
* violation of the copyright laws and may subject you to criminal prosecution.
<*/
import { SettingsManager } from '../configuration/SettingsManager'

export class UserEventLogger {
	static handleUserClickEvent(event: any, eventType: any, eventText: any) {
		const text = eventText ? eventText : event && event.currentTarget && event.currentTarget.textContent ? event.currentTarget.textContent.trim() : ''
		const rootUrl = SettingsManager.REACT_APP_MYABILITY_ROOT_URL().value

		let endurl = ''
		if (event && event.currentTarget) {
			endurl = event.currentTarget.href ? event.currentTarget.href : event.currentTarget.formAction ? event.currentTarget.formAction : ''
		}

		$.ajax({
			url: rootUrl + '/Home/ClickEvent',
			type: 'POST',
			dataType: 'JSON',
			data: { type: eventType, href: endurl, text: text },
			async: false,
			error: function() {
				return true
			},
		})

		return true
	}
}
